import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
    selector: 'app-stacked-bar',
    templateUrl: './stacked-bar.component.html',
    styleUrls: ['./stacked-bar.component.scss'],
    imports: [CommonModule, PipesModule]
})
export class StackedBarComponent {
    @Input() segments: { value: number; color: string }[] = [];
    @Input() total: number = 0;
    @Input() max: number = 0;  
    @Input() showLabel: boolean = true;
    @Input() neutralZonePercent: number = 10;
    @Input() isNegative: boolean = false;
    @Input() showZeroLine: boolean = false;
    @Input() showNeutralZone: boolean = false;
    marginOffset = '0px';  


    getWidth(value: number): string {
        const totalValue = this.showZeroLine ? this.total : Math.abs(this.total);

        const base = this.max || totalValue ;
        var width = ((value / base) * 100).toFixed(2) + '%';
        return width;
    }
    

    getNeutralZoneStyle() {
        return this.isNegative
            ? { right: 0, width: this.neutralZonePercent + '%' }
            : { left: 0, width: this.neutralZonePercent + '%' };
    }


    get zeroLineWrapperStyle() {
        return {
            left: this.neutralZonePercent + '%',
            position: 'absolute',
            top: '-5px',
            right: '0',
            height: '135 %',
            'border- left': '2.5px dotted',
            width: '0' 
        };
    }
    

    getTotalWidth(): number {   
        // numerator
        const totalValue = this.showZeroLine ? this.total : Math.abs(this.total);

        // denominator (prefer max; otherwise fall back to total or |total|)
        const base = (this.max != null && !isNaN(+this.max))
            ? this.max : totalValue;

        // avoid NaN / division by 0
        if (!Number.isFinite(base) || base === 0) return 0;

        return (totalValue / base) * 100;
    }

}

